module.exports = __webpack_public_path__ + "img/wine_button-REV.f7ab909b.png";